module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_86524110_L-3c0143c1983cc4298018116fc0be23d0.jpg";